import React from "react"
import {
  Button,
  CustomDialog
} from "../../../../mp-shared-components/generic-shared-components/components"
import { useStyles } from "./styles"
import { Box, Stack, Typography } from "@mui/material"
import Countdown, { zeroPad } from "react-countdown"
import { formatMilliseconds } from "./helpers"

interface Props {
  time?: number // milliseconds
  countdownTimer?: boolean
  logOutLoading?: boolean
  continueLoading?: boolean
  onLogOut: () => void
  onContinue: () => void
  onTimerComplete: () => void
}

const SessionTimeoutTimerDialog: React.FC<Props> = ({
  time,
  countdownTimer = true,
  logOutLoading = false,
  continueLoading = false,
  onLogOut,
  onContinue,
  onTimerComplete
}) => {
  const { classes } = useStyles()

  const timerRender = ({
    minutes,
    seconds
  }: {
    minutes: number
    seconds: number
  }) => (
    <Box className={classes.timer} aria-live="polite">
      <Typography variant="h2" component="span">
        {minutes}:{zeroPad(seconds)}
      </Typography>
    </Box>
  )

  return (
    <CustomDialog
      size="xs"
      open
      withCloseIcon={false}
      title="You will be logged out soon"
      actions={
        <>
          <Button
            size="md"
            variant="text"
            color="primary"
            loading={logOutLoading}
            disabled={logOutLoading || continueLoading}
            onClick={onLogOut}
          >
            Log Out
          </Button>
          <Button
            size="md"
            color="primary"
            variant="contained"
            loading={continueLoading}
            disabled={logOutLoading || continueLoading}
            onClick={onContinue}
          >
            Continue
          </Button>
        </>
      }
      classes={{
        paper: classes.dialogPaper,
        title: classes.dialogTitle,
        content: classes.dialogContent,
        actions: classes.dialogActions
      }}
    >
      <Stack spacing={5} alignItems="center">
        {countdownTimer && !!time && (
          <Countdown
            date={Date.now() + time}
            renderer={timerRender}
            onComplete={onTimerComplete}
          />
        )}

        <Typography variant="body2" textAlign="center">
          {`You will be logged out ${
            countdownTimer && !!time ? `in ${formatMilliseconds(time)} ` : ""
          }due to inactivity. If you want to continue, confirm you are still here.`}
        </Typography>
      </Stack>
    </CustomDialog>
  )
}

export default SessionTimeoutTimerDialog
